import NavigationHeader from '../../component/navigation_header';
import ScreenBackgroundWrapper from '../../component/screen_background_wrapper';
import './index_mWeb.css';
import { useLink } from 'react-router-stack';

import { RouteWrapper } from '../../component';

const SelectAvatarMWeb = ({
  avatarList,
  onSelectAvatar,
  avatarId,
  selectedBtnStyle,
  freeBtnStyle
}: any) => {
  const navigate = useLink();
  const onClickBack = () => {
    try {
      navigate.push('/');
    } catch (err) {
      navigate.go(-1);
    }
  };
  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <NavigationHeader onClickBack={onClickBack} title={'MyProfile'} bgColor />

        <div className="select_avatar_wrapper_mWeb">
          <div className="select_avar_primary_container_mWeb">
            <div className="select_avatar_primary_img_wrapper_mWeb">
              <img className="selected_avatar_img__mWeb" src={avatarList[avatarId]} />
            </div>
            <div className="title_mWeb">Select An Avatar</div>
          </div>

          <div className="select_avatar_list_wrapper_mWeb">
            {Object.values(avatarList).map((item: any, idx: any) => (
              <div className="select_avatar_list_container_mWeb" key={idx}>
                <div className="avatar_container_mWeb">
                  <div className="avatar_img_container_mWeb">
                    <img className="select_avatar_img_mWeb" src={item} />
                  </div>
                  {idx === avatarId ? (
                    <button className="avatar_btn_mWeb selected_mWeb" style={selectedBtnStyle}>
                      SELECTED
                    </button>
                  ) : (
                    <button
                      className="avatar_btn_mWeb free_mWeb"
                      style={freeBtnStyle}
                      onClick={() => onSelectAvatar(idx)}>
                      FREE
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};

export default SelectAvatarMWeb;
